import React, { useEffect, Suspense } from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import qs from 'query-string'
import NavBar from './EditorNavBar'
import EditorTitle from './EditorTitle'
import Register from './Register'
import EditTasks from './EditTask'
import Save from './Save'
import Payment from './Payment'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import { selectRequestsAreLoading } from 'state'
import { STATE_KEYS } from 'state/requests'
import { useSelector, useDispatch } from 'react-redux'
import Loading from 'components/Loading'
import { saveForm } from 'state/registrations'
import { getCampaignFieldsComments } from 'state/comments'
const CommentCenter = React.lazy(() => import('../CommentsCenter'))

const EditorContainer = styled.div`
    // 92px is #small-navbar height
    --small-navbar-height: 92px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    padding: 0 0 12px 24px;
    @media screen and (max-width: 768px) {
        padding: calc(var(--small-navbar-height) + env(safe-area-inset-top)) ${theme.newSpacing.xxs}
            ${theme.newSpacing.xxs} ${theme.newSpacing.xxs};
    }
    .main-block {
        display: grid;
        grid-template-columns: 1fr auto;
        height: 100%;
        overflow: hidden;
        gap: 24px;
        @media screen and (max-width: 768px) {
            gap: 0;
            .task-content {
                padding: 0;
            }
        }
    }

    .loader {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 50%;
    }
`

const Editor: React.FC = () => {
    const match = useRouteMatch()
    const prefix = match && match.path
    const isLoading = useSelector(selectRequestsAreLoading([STATE_KEYS.DuplicateCampaign]))
    const dispatch = useDispatch()
    const { campaign: uuid } = qs.parse(location.search)

    useEffect(() => {
        if (uuid && typeof uuid === 'string') {
            dispatch(getCampaignFieldsComments({ uuid: uuid }))
        }
        return (): void => {
            dispatch(saveForm(null))
        }
    }, [])

    return (
        <EditorContainer>
            {isLoading ? (
                <Loading className="loader" />
            ) : (
                <>
                    <EditorTitle />
                    <NavBar />
                    <div className="main-block">
                        <Route exact path={`${prefix}/registration`} component={Register} />
                        <Route path={`${prefix}/tasks`} component={EditTasks} />
                        <Route exact path={`${prefix}/publish`} component={Save} />
                        <Route exact path={`${prefix}/payment`} component={Payment} />
                        <Suspense fallback={<></>}>
                            <CommentCenter />
                        </Suspense>
                    </div>
                </>
            )}
        </EditorContainer>
    )
}

export default Editor
